import './App.css';
import React from "react";
import XelixNav from "./XelixNav";
import styles from "./styles.css";
export default function App() {
  
  return (
    <div className="App">
        <XelixNav />
      
        <div style={styles}></div>
    </div>
  );
}


